import { render } from "./NotePencilIcon.vue?vue&type=template&id=0a8e2c96&scoped=true"
import script from "./NotePencilIcon.vue?vue&type=script&lang=js"
export * from "./NotePencilIcon.vue?vue&type=script&lang=js"

import "./NotePencilIcon.vue?vue&type=style&index=0&id=0a8e2c96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8e2c96"]])

export default __exports__